module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-address-plugin-form"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.success),
      expression: "success"
    }],
    staticClass: "text-container"
  }, [_c('h2', [_vm._v("Danke für deine Bestellung beim Öpfelchasper.")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "text-container"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "order-address-form__link--before",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showForm.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                Zurück\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.success && !_vm.error)),
      expression: "(!success && !error)"
    }]
  }, [_c('form', {
    on: {
      "submit": _vm.validateForm
    }
  }, [_c('address-form', {
    ref: "addressForm",
    attrs: {
      "validate-form": _vm.validateForm,
      "early-invoice-text": "Wir möchten unsere Bestellung vor 10 Uhr morgens erhalten.<br>Der Aufpreis für die Öpfelchasper-Frühlieferung beträgt 5 CHF pro Lieferung.",
      "firm-required": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-address-plugin-form__btn-container"
  }, [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.validateForm.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                Testkorb bestellen\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Vielen Dank für deine Bestellung beim Öpfelchasper, wir bearbeiten sie so schnell wie möglich."), _c('br'), _vm._v("\n            Die Bestellbestätigung erhältst du schon bald per E-Mail."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n            Hast du noch Fragen? Wir beantworten dir sie gerne unter "), _c('a', {
    attrs: {
      "href": "tel:+41438186152"
    }
  }, [_vm._v("043 818 61 52")]), _vm._v(" oder per E-Mail unter "), _c('a', {
    attrs: {
      "href": "mailto:info@oepfelchasper.ch"
    }
  }, [_vm._v("info@oepfelchasper.ch")]), _vm._v(".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Deine Bestellung konnte nicht übermittelt werden."), _c('br'), _vm._v("\n            Bitte versuche es später noch einmal oder kontaktiere uns per Telefon oder E-Mail:"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+41438186152"
    }
  }, [_vm._v("043 818 61 52")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@oepfelchasper.ch"
    }
  }, [_vm._v("info@oepfelchasper.ch")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6518a1d8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/TestBasket/TestBasket.vue
// module id = 903
// module chunks = 0